export var KeyResource = [
    { name: '姓名', value: '$personalName' },
    { name: '金额', value: '$overdueAmount' },
    { name: '案件编号', value: '$caseNumber' },
    { name: '逾期次数', value: '$overdueDays' }
];
export var EditorOption = {
    placeholder: '请输入文本',
    // 配置各个模块
    modules: {
        // 配置工具栏的内容
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{
                    'list': 'ordered'
                }, {
                    'list': 'bullet'
                }, {
                    'list': 'check'
                }],
            [{
                    'header': [1, 2, 3, 4, 5, 6, false]
                }],
            [{
                    'color': []
                }, {
                    'background': []
                }],
            [{
                    'font': []
                }],
            [{
                    'align': []
                }],
            ['clean']
        ]
    }
};
